import React, { Component } from 'react';
import { Button, Theme, WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { dateService, MyPATDialog } from '../../../common';

const styles = (theme: Theme) => 
    createStyles({
        dialogCustomHeading: {
            fontSize: '1.5rem',
            fontWeight: 600,
            lineHeight: '138%',
            color: '#333333',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            textTransform: 'none',
            '& img': {
                position: 'absolute',
                right: 10,
                cursor: 'pointer',
            }
        },
        reasonsGroup: {
            maxHeight: '337px',
            padding: '0.63rem 0.38rem 1.38rem',
            overflowY: 'scroll',
            '& .reason-group-inner': {
                paddingBottom: '15px',
                border: '1px solid #E6E6E6',
                borderRadius: '6px',
                marginBottom: '1.5rem',
                '&: last-child': {
                  marginBottom: 0
                }
            },
            '& .reasons-panel': {
                padding: '0px 15px',
                '&:last-child': {
                    marginBottom: '0',
                },
                '& label': {
                    fontSize: '0.88rem',
                    fontWeight: 500,
                    lineHeight: '136%',
                    color: '#666666',
                    marginBottom: '0.63rem',
                    display: 'block',
                },
                '& .reasons-listing': {
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '0.54rem 0.94rem',
                    listStyle: 'none',
                    padding: '0px',
                    margin: '0px',
                    '& li': {
                        backgroundColor: '#F4F4F4',
                        borderRadius: '1.88rem',
                        fontSize: '0.88rem',
                        fontWeight: 500,
                        lineHeight: '136%',
                        color: '#666666',
                        padding: '0.5rem 0.63rem',
                    }
                },
                '& .comments': {
                    backgroundColor: 'rgba(246, 250, 244, 0.7)',
                    color: '#666666',
                    fontSize: '1rem',
                    fontWeight: 400,
                    lineHeight: '138%',
                    padding: '0.9375rem 0.9375rem',
                    borderRadius: '0.25rem',
                    marginBottom: '10px',
                    wordBreak: 'break-all'
                },
                '& .dateStrip': {
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    lineHeight: '136%',
                    display: 'inline-flex',
                    width: '100%',
                    justifyContent: 'space-between',
                    margin: '15px 0 10px',
                    alignItems: 'center',
                    color: '#666666',
                    position: 'relative',
                    '& span': {
                        padding: '0 10px 0 0',
                        background: '#ffffff',
                        zIndex: 1,
                        position: 'relative',
                    },
                    '&::after': {
                        content: "''",
                        position: 'absolute',
                        right: '0',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#E4E4E4',
                        height: '1px',
                        width: '100%',
                    }
                },

            }
        },
        buttonSection: {
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            padding: '18px 0',
            '& button': {
                minWidth: '5.88rem',
                height: '2.75rem',
                fontSize: '1rem',
                fontWeight: 500,
                lineHeight: '88%',
                padding: '0.94rem 1.69rem',
            }
        },
    });

interface RejectionReasonModalProps extends WithStyles<typeof styles> {
    classes: any;
    isModalOpen: boolean;
    onModalClose: Function;
    rejectionReasonData: any;
}

class RejectionReasonModal extends Component<RejectionReasonModalProps> {

    onModalCloseClick = () => {
        this.props.onModalClose();
    }
    render() {
        const { classes, isModalOpen, onModalClose, rejectionReasonData } = this.props;
        return (
          <MyPATDialog
            customDialogTitle={
                <div className={classes.dialogCustomHeading}>
                    Reasons for Rejection
                    <img onClick={this.onModalCloseClick} src="/assets/img/closeIcon.svg" alt="close"/>
                </div>
            }
            dialogOpen={isModalOpen}
            dialogHasActions={false}
            onDialogClose={this.onModalCloseClick}
            isAlignCenter={true}
            stopParentScroll={false}
            otherDialogProps={{
              fullWidth: true,
              maxWidth: "sm",
              scroll: "body",
            }}
            classes={{ root: classes.rejectReason }}
            customDialogActions={
              <div className={classes.buttonSection}>
                <Button
                  className={classes.primaryBtn}
                  autoFocus
                  variant="contained"
                  color="primary"
                  onClick={() => onModalClose()}
                >
                  Got it
                </Button>
              </div>
            }
          >
            <div className={classes.reasonsGroup}>
                    {(rejectionReasonData || []).map((entry: any, index: number) => {
                        return (
                            <div key={index} className="reason-group-inner">
                                <div className="reasons-panel">
                                    <div className="dateStrip">
                                        <span>{dateService.convertDate(entry.dateofComment)}</span>
                                    </div>
                                    {
                                       entry.rejectionComment && 
                                        <div className="comments">
                                            { entry.rejectionComment }
                                        </div>
                                    }
                                    <label>Reason(s) for Rejection</label>
                                    <ul className="reasons-listing">
                                        {
                                         (entry.rejectionReasons || []).map((reason: any) => (
                                                <li>{reason.name}</li>
                                         ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        );
                    })}
                </div>
          </MyPATDialog>
        );
    }
}

// @ts-ignore
export default (withStyles(styles)(RejectionReasonModal));
